<template>
  <div class="app-container">
    <ProtalHeader />
    <div class="main-containet">
      <router-view />
    </div>
    <ProtalFooter />
  </div>
</template>

<script>
import ProtalHeader from './components/ProtalHeader.vue'
import ProtalFooter from './components/ProtalFooter.vue'

export default {
  components: {
    ProtalHeader,
    ProtalFooter
  }

}
</script>
